import { type AxiosInstance } from "axios";
import {
  type PostOauthTokenRequest,
  type SalesforceConnectionResponse,
} from "@/features/salesforceIntegration/types";

/**
 * OAuthコールバックで受け取った認可コードをバックエンドへ渡し、トークン交換を行う
 * （`POST /salesforce/oauth/token/`）。
 * 成功時は接続状態と同じ形のレスポンスが返る（完了画面での表示に使う）。
 */
export const postOauthToken = async (
  apiClient: AxiosInstance,
  body: PostOauthTokenRequest
): Promise<SalesforceConnectionResponse> => {
  const { data } = await apiClient.post<SalesforceConnectionResponse>(
    "/salesforce/oauth/token/",
    body
  );
  return data;
};
